<template>
  <div class="embed-modal-custom-footer">
    <div>
      <Button :variant="ButtonVariant.TERTIARY" :text="$t('close')" @click="close" />
    </div>
    <div class="get-code-section">
      <Button v-if="!props.extraProps?.embedCode" @click="handleGetCodeClick()">
        {{ t('get-code') }}
      </Button>
      <WithIconButton v-else :variant="ButtonVariant.SECONDARY" icon-name="editBlueIcon" @click="startEditing">
        {{ t('edit-selection') }}
      </WithIconButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ButtonVariant } from '@/styles/types'
import Button from '@/components/common/buttons/Button.vue'
import WithIconButton from '@/components/common/buttons/WithIconButton.vue'
import { useI18n } from 'vue-i18n'
import { CustomModalProps } from '@/interfaces'
import { useStore } from 'vuex'
import { inject } from 'vue'
import { MODAL_ACTIONS_INJECTION_KEY } from '@/constants'

const { t } = useI18n()
const store = useStore()

const props = defineProps<CustomModalProps>()

const handleGetCodeClick = async () => {
  const payload = store.getters['modal/getModalPayload']()
  await payload.getCode()
}
const startEditing = async () => {
  const payload = store.getters['modal/getModalPayload']()
  await payload.startEditing()
}
const modalAction = inject(MODAL_ACTIONS_INJECTION_KEY) as () => Promise<void>

const close = async () => {
  await modalAction()
}
</script>

<style lang="scss" scoped>
.embed-modal-custom-footer {
  display: flex;
  justify-content: space-between;
}
</style>
